module.exports = __webpack_public_path__ + "static/img/sc18.53154e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc18.png
// module id = clro
// module chunks = 25